export const STATUSES = ["Not Sent", "Sent", "Replied", "Meeting Booked", "No Response", "Passed"];
export const PRIORITIES = ["High", "Medium", "Low"];
export const CATEGORIES = ["A&R", "Label Manager", "Agent", "Management", "Artist Relations"];
export const REPLIES = ["Yes", "No", "Pending"];
export const YES_NO = ["Yes", "No"];

export const SCORE_FIELDS = [
  { key: "routeQuality", label: "Contact route", options: ["Named person", "Label inbox", "ADE Pro / in-person", "Form / portal", "None"] },
  { key: "adePresence", label: "ADE presence", options: ["Confirmed", "Likely", "Unlikely"] },
  { key: "fitStrength", label: "Sound fit", options: ["Strong", "Medium", "Weak"] },
  { key: "warmAngle", label: "Warm angle (shared bill / intro)", options: ["Yes", "No"] },
];

export const scoreColor = (s) => (s >= 70 ? "#34D399" : s >= 50 ? "#FCD34D" : "#94A3B8");
export const todayISO = () => new Date().toISOString().slice(0, 10);

export const PRIORITY_STYLE = {
  High: { color: "#FCA5A5", bg: "rgba(239,68,68,0.15)", border: "rgba(239,68,68,0.4)", dot: "#EF4444" },
  Medium: { color: "#FCD34D", bg: "rgba(245,158,11,0.15)", border: "rgba(245,158,11,0.4)", dot: "#F59E0B" },
  Low: { color: "#93C5FD", bg: "rgba(59,130,246,0.15)", border: "rgba(59,130,246,0.4)", dot: "#3B82F6" },
};

export const STATUS_STYLE = {
  "Not Sent": { color: "#94A3B8", bg: "rgba(100,116,139,0.15)", border: "rgba(100,116,139,0.3)" },
  Sent: { color: "#38BDF8", bg: "rgba(56,189,248,0.15)", border: "rgba(56,189,248,0.35)" },
  Replied: { color: "#FBBF24", bg: "rgba(251,191,36,0.15)", border: "rgba(251,191,36,0.35)" },
  "Meeting Booked": { color: "#34D399", bg: "rgba(52,211,153,0.2)", border: "rgba(52,211,153,0.4)" },
  "No Response": { color: "#FB7185", bg: "rgba(251,113,133,0.15)", border: "rgba(251,113,133,0.35)" },
  Passed: { color: "#64748B", bg: "rgba(71,85,105,0.2)", border: "rgba(71,85,105,0.3)" },
};

export const VIEWS = [
  { id: "labels", label: "Labels & A&R" },
  { id: "management", label: "Management & Booking" },
  { id: "pre", label: "Pre-ADE Actions" },
  { id: "post", label: "Post-ADE Actions" },
  { id: "templates", label: "Email Templates" },
  { id: "assets", label: "Assets Checklist" },
  { id: "playbook", label: "Playbook" },
];
